var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table-lite',{staticClass:"shadow-sm",attrs:{"bordered":"","no-border-collapse":"","striped":"","outlined":"","items":_vm.items,"fields":_vm.fields,"sticky-header":"400px","table-class":"table-va-middle"}})}
var staticRenderFns = []

export { render, staticRenderFns }